<form [formGroup]="form">
  <aw-section [testIdAffix]="'mask-' + mask().id">
    <aw-section-header>
      <aw-section-headline> {{ mask().name }} </aw-section-headline>
    </aw-section-header>
    <div class="grid grid-cols-12 gap-4">
      @for (row of rows(); track $index) {
        @for (field of row; track field.id) {
          @let colEnd =
            $index < row.length - 1 && row[$index + 1]
              ? row[$index + 1].colStart
              : 13;
          <div
            [formGroup]="form"
            [style.grid-column-start]="field.colStart"
            [style.grid-column-end]="colEnd"
            [style.grid-row]="field.row">
            @switch (field.datatype) {
              @case (SubscriptionDataTypes.String) {
                <aw-text-input
                  [formControlName]="field.internalName"
                  [id]="field.name"
                  [label]="field.name">
                  <div>Here be Errors for Text Input</div>
                </aw-text-input>
              }
              @case (SubscriptionDataTypes.Guid) {
                <aw-text-input
                  [formControlName]="field.internalName"
                  [id]="field.name"
                  [label]="field.name">
                  <div>Here be Errors for Text Input</div>
                </aw-text-input>
              }
              @case (SubscriptionDataTypes.EMail) {
                <aw-text-input
                  [id]="field.name"
                  [label]="field.name"
                  [formControlName]="field.internalName">
                </aw-text-input>
              }
              @case (SubscriptionDataTypes.Boolean) {
                <div class="flex flex-col gap-4">
                  <aw-checkbox
                    [formControlName]="field.internalName"
                    [label]="field.name"
                    [id]="field.name">
                  </aw-checkbox>

                  @if (isCheckBoxChecked(field)) {
                    <aw-dynamic-mask-form
                      [mask]="
                        getInlineMask(field.followingMaskGuid)!
                      "></aw-dynamic-mask-form>
                  }
                </div>
              }

              @case (SubscriptionDataTypes.Date) {
                <aw-date-input
                  [formControlName]="field.internalName"
                  [label]="field.name"
                  [id]="field.name"
                  [showTimePicker]="false"
                  [min]="toDate(field.earliestDate)"
                  [max]="toDate(field.latestDate)"
                  [restrictedDateList]="listDatesToDate(field.listDates)">
                  <div>Here be Errors for Date Input</div>
                </aw-date-input>
              }

              @case (SubscriptionDataTypes.Integer) {
                <aw-number-input
                  [formControlName]="field.internalName"
                  [label]="field.name"
                  [id]="field.name">
                  <div>Here be Errors for Date Input</div>
                </aw-number-input>
              }
              @case (SubscriptionDataTypes.SelectionField) {
                <aw-drop-down
                  [formControlName]="field.internalName"
                  [label]="field.name"
                  [id]="field.name"
                  name="name"
                  valueAttribute="value"
                  [options]="field.dropdownOptions!">
                  <div>Here be Errors for Drop Down</div>
                </aw-drop-down>
              }
              @case (SubscriptionDataTypes.Label) {
                <div [innerHTML]="field.description"></div>
              }
              @default {
                <p>Unsupported field type: {{ field.datatype }}</p>
              }
            }
          </div>
        }
      }
    </div>
  </aw-section>
</form>
